import { getListName } from 'analytics/enhanced-ecommerce'
import OfferCardCarouselSection from 'components/Common/OfferCardCarousel/OfferCardCarouselSection'
import { OfferListEventsProvider } from 'components/OfferList/OfferListEventsContext'
import Places from 'constants/places'
import useOfferListTracking from 'hooks/Offers/useOfferListTracking'
import { useAppSelector } from 'hooks/reduxHooks'
import { getSearchQueryFromFilter } from 'lib/search/searchUtils'
import { getIsEnabledLuxPlusCruiseInclusions } from 'luxPlus/selectors/featureToggle'
import React from 'react'
import { LUX_PLUS_MONTH_CAMPAIGN_ID } from 'takeovers/luxPlusMonthTakeover/constants/luxPlusMonthTakeoverConstants'

const FILTERS: App.OfferListFilters = {
  offerTypes: ['cruise'],
  destinations: [Places.Anywhere.id],
  campaigns: [LUX_PLUS_MONTH_CAMPAIGN_ID],
  sortBy: 'luxPlusList',
  isLuxPlus: true,
  limit: 20,
}

const ALL_LINK = `/search/cruises?${getSearchQueryFromFilter(FILTERS)}`

interface Props {
  analyticsPage: string
}

function LuxPlusMonthCruisesOfferCarousel({ analyticsPage }: Props) {
  const isEnabledLuxPlusCruiseInclusions = useAppSelector(getIsEnabledLuxPlusCruiseInclusions)
  const tracking = useOfferListTracking(getListName('OfferList', analyticsPage, 'Cruise bonus inclusions'))
  if (!isEnabledLuxPlusCruiseInclusions) return null

  return <OfferListEventsProvider tracking={tracking}>
    <OfferCardCarouselSection
      tileSize="medium"
      title={<><i>More onboard credits</i> on a LuxPlus+ Month cruise</>}
      filters={FILTERS}
      allLink={ALL_LINK}
      hideWhenEmpty
      id="cruise_inclusions"
    />
  </OfferListEventsProvider>
}

export default LuxPlusMonthCruisesOfferCarousel
